/// <reference path="./lib/matchers-types.ts" />
export { Spec } from './lib/spec/spec';
export { SpecOptions } from './lib/spec/options';
export { createComponentFactory, SpecFactory, SpecOverrides } from './lib/spec/create-factory';
export { initialSpecModule } from './lib/spec/initial-module';

export { SpecHost } from './lib/spec-host/spec-host';
export { SpecHostOptions } from './lib/spec-host/options';
export { createHostFactory, SpecHostFactory, SpecHostOverrides } from './lib/spec-host/create-factory';
export { initialSpecWithHostModule } from './lib/spec-host/initial-module';
export { HostComponent, HostModule } from './lib/spec-host/host-component';

export { SpecDirective } from './lib/spec-directive/spec-directive';
export { SpecDirectiveOptions } from './lib/spec-directive/options';
export { createDirectiveFactory, SpecDirectiveFactory, SpecDirectiveOverrides } from './lib/spec-directive/create-factory';
export { initialSpecDirectiveModule } from './lib/spec-directive/initial-module';

export { SpecService } from './lib/spec-service/spec-service';
export { SpecServiceOptions } from './lib/spec-service/options';
export { SpecServiceFactory, createServiceFactory, SpecServiceOverrides } from './lib/spec-service/create-factory';

export { SpecRouting } from './lib/spec-routing/spec-routing';
export { SpecRoutingOptions } from './lib/spec-routing/options';
export { SpecRoutingFactory, createRoutingFactory, SpecRoutingOverrides } from './lib/spec-routing/create-factory';
export { ActivatedRouteStub } from './lib/spec-routing/activated-route-stub';

export { SpecHttp, HttpMethod } from './lib/spec-http/spec-http';
export { SpecHttpOptions } from './lib/spec-http/options';
export { SpecHttpFactory, createHttpFactory, CreateHttpOverrides } from './lib/spec-http/create-factory';

export { SpecPipe } from './lib/spec-pipe/spec-pipe';
export { SpecPipeOptions } from './lib/spec-pipe/options';
export { createPipeFactory, SpecPipeFactory, SpecPipeOverrides } from './lib/spec-pipe/create-factory';
export { initialSpecPipeModule } from './lib/spec-pipe/initial-module';

export * from './lib/dom-selectors';
export * from './lib/matchers';
export * from './lib/mock';
export * from './lib/token';
export * from './lib/types';
export { typeInElement } from './lib/type-in-element';
export { defineGlobalsInjections } from './lib/globals-injections';
export { dispatchEvent, dispatchFakeEvent, dispatchKeyboardEvent, dispatchMouseEvent, dispatchTouchEvent } from './lib/dispatch-events';
export { createFakeEvent, createKeyboardEvent, createMouseEvent, createTouchEvent } from './lib/event-creators';
export { MockComponentDeprecated, MockDirectiveDeprecated } from './lib/deprecated';
